export const SAFEHARBOR_NETWORK = "Safe Harbor"
export const DOCKWA_NETWORK = "Dockwa"
export const ADD_NEW_BOAT = "addNew"
export const ADD_NEW_CONTACT = "addNew"
